<template>
  <div>
    <v-toolbar class="elevation-0">
      <v-toolbar-title class="pl-0">{{ title }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn text color="primary" :disabled="!itemsSelected || itemsSelected.length === 0" @click="copyDocuments()">
        <v-icon left>mdi-content-copy</v-icon> Copiar CPFs
      </v-btn>
      <v-btn v-if="!!isBackoffice" text color="primary" :to="{ name: 'newMultipleJoined', params: { fundraisingId, celebrationId } }">
        <v-icon left>mdi-account-plus</v-icon> Adicionar
      </v-btn>
      <v-menu offset-y v-if="!!isBackoffice">
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" text color="primary" :disabled="!itemsSelected || itemsSelected.length === 0">
            <v-icon>mdi-format-list-checks</v-icon> Ações <v-icon>mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="modalEditMultiple = 'installment'">
            <v-list-item-content>
              <v-list-item-title>Alterar número de parcelas</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="modalEditMultiple = 'goal'">
            <v-list-item-content>
              <v-list-item-title>Alterar meta</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="modalEditMultiple = 'addToGoal'">
            <v-list-item-content>
              <v-list-item-title>Adicionar valor a meta</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
      <div class="d-flex mr-n4 align-center">
        <quicksearch v-model="quicksearch"></quicksearch>
      </div>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      :disable-pagination="true"
      :no-data-text="noResultText"
      :no-results-text="noResultText"
      :hide-default-footer="true"
      :search="quicksearch"
      :show-select="true"
      v-model="itemsSelected"
    >
      <template v-slot:item.actions="{ item }">
        <div class="no-wrap">
          <v-btn v-if="item.joined_id" @click="editItem = { id: item.joined_id, item: item, show: true }" color="primary" fab text small dark>
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn v-else :to="{ name: 'newJoined', params: { fundraisingId: item.id, celebrationId }, query: { participant: participantId } }" color="primary" fab text small dark>
            <v-icon>mdi-account-plus</v-icon>
          </v-btn>
          <v-btn v-if="item.joined_id" @click="copyToClipboard(item.joined_id)" color="primary" fab text small dark>
            <v-icon>mdi-code-tags</v-icon>
          </v-btn>
        </div>
      </template>
      <template v-slot:item.name="{ item }">
        {{ item.name }} <template v-if="item.nickname"><br>({{ item.nickname }})</template>
      </template>
      <template v-slot:item.person_document="{ item }">
        {{ item.person_document | document }}
      </template>
      <template v-slot:item.joined_created_at="{ item }">
        {{ item.joined_created_at | moment('MM/YYYY') }}
      </template>
      <template v-slot:item.amount_to_pay="{ item }">
        <span style="white-space: nowrap">{{ item.amount_to_pay | price }}</span>
      </template>
      <template v-slot:item.total_paid="{ item }">
        <span style="white-space: nowrap">{{ item.total_paid | price }}</span>
      </template>
      <template v-slot:item.total_paid_before="{ item }">
        <span style="white-space: nowrap">{{ item.total_paid_before | price }}</span>
      </template>
      <template v-slot:item.total_paid_without_interest_and_fine="{ item }">
        <span style="white-space: nowrap">{{ item.total_paid_without_interest_and_fine | price }}</span>
      </template>
      <template v-slot:item.total_paid_interest_and_fine="{ item }">
        <span style="white-space: nowrap">{{ item.total_paid_interest_and_fine | price }}</span>
      </template>
      <template v-slot:item.total_late="{ item }">
        <span style="white-space: nowrap">{{ item.total_late | price }}</span>
      </template>
      <template v-slot:item.total_pending="{ item }">
        <span style="white-space: nowrap">{{ item.total_pending | price }}</span>
      </template>
      <template v-slot:item.total_financial_negotiations="{ item }">
        <span style="white-space: nowrap">{{ item.total_financial_negotiations | price }}</span>
      </template>
      <template v-slot:item.payment_method="{ item }">
        <template v-if="item.number_of_installment">
          {{ item.number_of_installment }}x ({{ item.method | payment_method }}<template v-if="item.period && item.period !== 'ALL'"> | {{ item.period }}</template>)
        </template>
        <template v-else>
          Sem parcelas
        </template>
      </template>
    </v-data-table>
    <edit-modal
      :id="editItem.id"
      :item="editItem.item"
      v-if="editItem.show"
      @canceled="editItem.show = false"
      @error="editItem.show = false"
      @edited="editItem.show = false; $emit('edited')"
    ></edit-modal>
    <edit-multiple-modal
      :type="modalEditMultiple"
      :items="itemsSelected"
      v-if="modalEditMultiple"
      @canceled="modalEditMultiple = false"
      @error="modalEditMultiple = false"
      @edited="modalEditMultiple = false; $emit('edited')"
    ></edit-multiple-modal>
  </div>
</template>

<script>
import Quicksearch from '@/components/Quicksearch'
import EditModal from '@/components/EditModals/Joined'
import EditMultipleModal from '@/components/EditModals/JoinedMultiple'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'participants',
  components: {
    Quicksearch,
    EditModal,
    EditMultipleModal
  },
  props: {
    type: {
      type: String,
      default: 'fundraisings'
    },
    fundraisingId: {
      type: String
    },
    participantId: {
      type: String
    },
    celebrationId: {
      type: String
    },
    allItems: {
      type: [String, Array],
      default: () => []
    }
  },
  data () {
    return {
      loading: false,
      quicksearch: '',
      items: [],
      headers: [
        {
          text: '',
          value: 'actions',
          sortable: false
        },
        {
          text: 'Nome',
          value: 'name'
        },
        {
          text: 'CPF/CNPJ',
          value: 'person_document'
        },
        {
          text: 'Entrou em',
          value: 'joined_created_at'
        },
        {
          text: 'Total',
          value: 'amount_to_pay'
        },
        {
          text: 'Total Pago',
          value: 'total_paid'
        },
        {
          text: 'Pago por fora',
          value: 'total_paid_before'
        },
        {
          text: 'Pago Heppi',
          value: 'total_paid_without_interest_and_fine'
        },
        {
          text: 'Juros pago',
          value: 'total_paid_interest_and_fine'
        },
        {
          text: 'Atrasado',
          value: 'total_late'
        },
        {
          text: 'Forma de pagamento',
          value: 'payment_method'
        }
      ],
      editItem: {
        item: {},
        id: null,
        show: false
      },
      itemsSelected: [],
      modalEditMultiple: false
    }
  },
  computed: {
    ...mapGetters(['isBackoffice']),
    title () {
      return 'Participantes (' + this.items.length + ')'
    },
    noResultText () {
      return 'Nenhum participante'
    }
  },
  watch: {
    allItems (val) {
      this.items = val
    }
  },
  methods: {
    ...mapActions(['copyToClipboard']),
    copyDocuments () {
      this.copyToClipboard(this.itemsSelected.map(e => e.person_document).join(','))
    }
  },
  mounted () {
    if (this.allItems && this.allItems.length > 0) {
      this.items = this.allItems
    } else {
      this.items = []
    }
  }
}
</script>
